import { api } from "./api.ts";

/** Unread notifications (ADR-0022), for the link to the inbox; checked every minute. */
export const unreadQuery = {
  queryKey: ["inbox", "unread"] as const,
  queryFn: () => api<{ count: number }>("/inbox/unread"),
  refetchInterval: 60_000,
};
